import { useState, useCallback } from 'react';

export interface MenuState {
  menuOpen?: boolean;
  anchorEl?: HTMLElement | null;
  onMenuClose(): void;
  onMenuClick(event: React.MouseEvent<HTMLElement>): void;
}

export const useMenuState = (): MenuState => {
  const [menuOpen, setIsMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return {
    anchorEl,
    menuOpen,
    onMenuClose: useCallback(() => {
      setAnchorEl(null);
      setIsMenuOpen(false);
    }, []),
    onMenuClick: useCallback((event) => {
      setAnchorEl(event && event.currentTarget ? event.currentTarget : null);
      setIsMenuOpen(true);
    }, [])
  };
};
